import { ActionReducerMap } from "@ngrx/store";
import { carouselReducer } from "./fetch_carousel.reducer";
import { categoriesReducer } from './fetch-categories.reducer';
import { topProductsReducer } from './fetch_topFeatureProducts.reducer';

export const HomePageReducer: ActionReducerMap<any> = {
    fetchCarouselImages: carouselReducer,
    fetchCategories: categoriesReducer,
    fetchTopFeatureProducts:topProductsReducer
};
